import { ApiResult, Methods, QueryWrapper } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class CountersignRecordSheetApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'countersign-record-sheet'
  }

  public deleteByFilter1(OutgoingId) {
    return this.send({OutgoingId:OutgoingId},"deleteByFilter",this.Methods.GET)
  }

}